var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_26._Student",
    "data-name": " 26. Student"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.7,767.63l-35.37-57.77-2.01-32.13h-27.96c-9.06-3.72-19.06-4.48-28.58-2.16-24.4-7.71-37.93-33.75-30.22-58.15,6-18.98,23.45-32.01,43.35-32.36h30.89v-108.12h-154.46c-10.64-.05-20.56,5.37-26.26,14.37l-77.23,123.57c-9.13,14.41-4.84,33.5,9.57,42.63,4.99,3.16,10.78,4.82,16.69,4.79h65.65l-2.93,46.34c-40.47,63.79-42.01,63.33-41.24,77.23l9.42,154.46c0,17.06,13.83,30.89,30.89,30.89s30.89-13.83,30.89-30.89l8.5-139.02,41.24-46.34h24.1l42.32,46.34,7.41,139.02c0,17.06,13.83,30.89,30.89,30.89s30.89-13.83,30.89-30.89l8.19-154.46c.39-6.41-1.23-12.78-4.63-18.23h0ZM208.87,600.5l15.45-24.56-1.54,24.56h-13.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 307.57,
    cy: 415.14,
    r: 92.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.43,
    y: 662.28,
    width: 494.28,
    height: 61.79,
    rx: 15.45,
    ry: 15.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.66,971.21h-30.89l-15.45-247.14h61.79l-15.45,247.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.38,971.21h-30.89l-15.45-247.14h61.79l-15.45,247.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1033.55,388.26c-14.82-8.45-33.69-3.29-42.14,11.53,0,.02-.02.03-.03.05l-50.51,88.82c-20.33-5.21-40.96-9.13-61.79-11.74h-154.46c-10.64-.05-20.56,5.37-26.26,14.37l-77.23,123.57c-9.13,14.41-4.84,33.5,9.57,42.63,4.99,3.16,10.78,4.82,16.69,4.79h108.12c17.06,0,30.89-13.83,30.89-30.89s-13.83-30.89-30.89-30.89h-52.36l21.47-34.45v19h30.89c25.59.5,45.93,21.64,45.43,47.23-.39,20.27-13.92,37.93-33.39,43.6-8.6-1.79-17.54-1.15-25.8,1.85h-29.66l-2.01,30.89c-40.47,63.79-42.01,63.33-41.24,77.23l9.42,154.46c0,17.06,13.83,30.89,30.89,30.89s30.89-13.83,30.89-30.89l8.5-139.02,41.24-46.34h24.1l42.32,46.34,7.41,139.02c0,17.06,13.83,30.89,30.89,30.89s30.89-13.83,30.89-30.89l8.19-154.46c0-12.36-1.24-12.67-40.01-75.84l-10.5-169.91,67.19,13.44c13.16,2.53,26.44-3.71,32.9-15.45l61.79-108.12c8.18-14.7,3.1-33.23-11.43-41.71h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 801.86,
    cy: 353.35,
    r: 92.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.48,152.55v92.68c0,17.06,13.83,30.89,30.89,30.89h154.46l22.71,23.17c1.86,1.88,4.89,1.89,6.77.02.91-.91,1.42-2.14,1.41-3.42v-143.34c0-17.06-13.83-30.89-30.89-30.89h-154.46c-17.06,0-30.89,13.83-30.89,30.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 523.82,
    cy: 198.89,
    r: 15.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 585.61,
    cy: 198.89,
    r: 15.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 647.39,
    cy: 198.89,
    r: 15.45
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 554.72,
    y: 662.28,
    width: 494.28,
    height: 61.79,
    rx: 15.45,
    ry: 15.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M631.95,971.21h-30.89l-15.45-247.14h61.79l-15.45,247.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1002.66,971.21h-30.89l-15.45-247.14h61.79l-15.45,247.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.57,662.28c-8.53,0-15.45-6.9-15.46-15.43,0-1.96.37-3.91,1.1-5.73l30.89-77.23c3.16-7.93,12.15-11.81,20.08-8.65,7.93,3.16,11.81,12.15,8.65,20.08l-30.89,77.23c-2.34,5.88-8.04,9.74-14.37,9.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462.04,662.28h-108.12c-17.06,0-30.89-13.83-30.89-30.89s13.83-30.89,30.89-30.89h52.36l-47.73-76.31c-9.04-14.5-4.62-33.59,9.89-42.63,14.5-9.04,33.59-4.62,42.63,9.89l77.23,123.57c9.04,14.47,4.64,33.53-9.82,42.57-4.93,3.08-10.62,4.71-16.44,4.7h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.efd3e6606e79d0e1a7e2b8f0d0055a41.svg";
export { ForwardRef as ReactComponent };